import React from 'react';

import './Arrecode.css';
import './wordsPosition.css';

const Arrecode = () => {

    return (
    <div className="principal">



        <div className="containerArrecode">

            <span id="a" className="principal_word" >a</span>
            <span id="r1" className="principal_word">r</span>
            <span id="r2" className="principal_word">r</span>
            <span id="e1" className="principal_word">e</span>
            <span id="openBr" className="principal_word">[</span>
            <span id="c" className="principal_word code">c</span>
            <span id="o" className="principal_word code">o</span>
            <span id="d" className="principal_word code">d</span>
            <span id="e2" className="principal_word code">e</span>
            <span id="closeBr" className="principal_word">]</span>

            <span id="x" className="axel ">x</span>
            <span id="e" className="axel ">e</span>
            <span id="l" className="axel ">l</span>

            <span id="e" className="rene ">e</span>
            <span id="n" className="rene ">n</span>
            <span id="e2" className="rene ">é</span>

            <span id="reneShape"></span>

            <span id="o" className="romero ">o</span>
            <span id="m" className="romero ">m</span>
            <span id="e" className="romero ">e</span>
            <span id="r" className="romero ">r</span>
            <span id="o2" className="romero ">o</span>

            <span id="s" className="esquivel ">s</span>
            <span id="q" className="esquivel ">q</span>
            <span id="u" className="esquivel ">u</span>
            <span id="i" className="esquivel ">i</span>
            <span id="v" className="esquivel ">v</span>
            <span id="e" className="esquivel ">e</span>
            <span id="l" className="esquivel ">l</span>

            <span id="esquivelShape"></span>

            <span id="fullstack"><i>Fullstack Web</i></span>
            <span id="andand"><i>&&</i></span>
            <span id="software"><i>Python Developer</i></span>

        </div>

    </div>
    )
}

export default Arrecode
